// extracted by mini-css-extract-plugin
export var sliderRange = "_da-2";
export var sliderRoot = "_da-0";
export var sliderThumb = "_da-3";
export var sliderTrack = "_da-1";